module.exports = __webpack_public_path__ + "img/myposition_fb.cb94df42.svg";